import { useEffect, useState } from "react";
import { useSearchParams, Link, useLocation } from "react-router-dom";
import { apiRequest } from "../services/apiClient";

export default function InvoicePaymentResultPage() {
  const [params] = useSearchParams();
  const location = useLocation();
  const [status, setStatus] = useState("checking");
  const [message, setMessage] = useState("");
  const invoice = params.get("invoice") || "";
  const sessionId = params.get("session_id") || "";
  const cancelled = location.pathname.endsWith("cancelled");

  useEffect(() => {
    if (cancelled) { setStatus("cancelled"); return; }
    if (!invoice || !sessionId) { setStatus("error"); setMessage("The payment session is incomplete."); return; }
    apiRequest(`/invoice-payment/${encodeURIComponent(invoice)}/verify?session_id=${encodeURIComponent(sessionId)}`)
      .then(result => setStatus(result.paymentStatus === "paid" ? "paid" : "pending"))
      .catch(error => { setStatus("error"); setMessage(error.message); });
  }, [cancelled, invoice, sessionId]);

  const content = {
    checking: ["Confirming payment", "Please wait while we confirm your Stripe payment."],
    paid: ["Payment received", `Invoice ${invoice} is now marked as paid.`],
    pending: ["Payment processing", "Stripe has received the session, but payment is not confirmed yet."],
    cancelled: ["Payment cancelled", "No payment was made. You can return to the invoice email and try again."],
    error: ["Payment verification failed", message || "Please contact Circuit Printing Solutions."],
  }[status];

  return <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, background: "#f7fafc" }}><div style={{ maxWidth: 520, width: "100%", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: 36, textAlign: "center" }}><img src="/logo.jpeg" alt="Circuit Printing Solutions" style={{ maxWidth: 150, maxHeight: 64, objectFit: "contain" }} /><h1 style={{ color: "#19356a", fontSize: 26, margin: "24px 0 10px" }}>{content[0]}</h1><p style={{ color: "#4b5563", lineHeight: 1.6 }}>{content[1]}</p><Link to="/" className="btn-primary" style={{ display: "inline-block", marginTop: 20 }}>Return to Circuit Printing</Link></div></div>;
}
